<template>
  <b-navbar
    toggleable="lg"
    :variant="getLayoutNavbarBg()"
    class="layout-navbar align-items-lg-center container-p-x"
  >
    <!-- Brand demo (see demo.css) -->
    <b-navbar-brand to="/" class="app-brand demo d-lg-none py-0 mr-4">
      <span class="app-brand-logo demo bg-primary">
        <img :src="`@/assets/images/logo.svg`" alt="SIPAMER" />
      </span>
    </b-navbar-brand>

    <!-- Sidenav toggle (see demo.css) -->
    <b-navbar-nav
      class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto"
      v-if="sidenavToggle"
    >
      <a
        class="nav-item nav-link px-0 mr-lg-4"
        href="javascript:void(0)"
        @click="toggleSidenav"
      >
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>

    <b-collapse is-nav id="app-layout-navbar">
      <!-- Divider -->
      <hr class="d-lg-none w-100 my-2" />

      <b-navbar-nav class="align-items-lg-center ml-auto">
        <b-nav-item-dropdown
          no-caret
          :right="!isRTL"
          class="demo-navbar-notifications mr-lg-3"
        >
          <template slot="button-content">
            <i
              class="ion ion-md-notifications-outline navbar-icon align-middle"
            ></i>
            <span
              class="badge badge-danger badge-dot indicator"
              v-if="notification.length > 0"
            ></span>
            <span class="d-lg-none align-middle">&nbsp; Notifications</span>
          </template>

          <div class="bg-primary text-center text-white font-weight-bold p-3">
            {{ notification.length }} Pemberitahuan Baru
          </div>
          <b-list-group flush>
            <!-- <template v-if="NotifTes.length > 0">
              <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center" v-for="(message,key) in NotifTes" :key="key">
                <div class="ui-icon ui-icon-sm ion ion-md-home bg-secondary border-0 text-white"></div>
                <div class="media-body line-height-condenced ml-3">
                  <div class="text-dark">Laporan Merkuri Terkonfirmasi</div>
                  <div class="text-light small mt-1">
                    <a @click="updatestatus(message)" v-if="message.status == 0">
                      {{ message.message }}
                    </a>  
                  </div>
                  <div class="text-light small mt-1">Mohon cek laporan merkuri {{ message.timestamp }}</div>
                </div>
              </b-list-group-item>
            </template> -->

            <template v-if="notification.length > 0">
              <b-list-group-item
                @click="updateread(item.id, item.data.tipe)"
                class="media d-flex align-items-center"
                v-for="(item, key) in notification"
                :key="key"
              >
                <div
                  class="
                    ui-icon ui-icon-sm
                    ion ion-md-home
                    bg-secondary
                    border-0
                    text-white
                  "
                ></div>
                <div class="media-body line-height-condenced ml-3">
                  <div class="text-dark">
                    {{ item.data.title }}
                  </div>
                  <div class="text-light small mt-1">
                    <a>
                      {{ item.data.description }}
                    </a>
                  </div>
                  <div class="text-light small mt-1">
                    Mohon cek laporan merkuri {{ item.data.timestamp }}
                  </div>
                </div>
              </b-list-group-item>
            </template>
          </b-list-group>

          <a
            href="/app/notification"
            class="d-block text-center text-dark small p-2 my-1"
            >Tampilkan Semua Pemberitahuan</a
          >
        </b-nav-item-dropdown>

        <!-- Divider -->
        <!-- <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">|</div> -->

        <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
          <template slot="button-content">
            <span
              class="
                d-inline-flex
                flex-lg-row-reverse
                align-items-center align-middle
              "
            >
              <img
                :src="$storageAsset(currentUser.user.foto_profile)"
                alt
                class="d-block ui-w-30 rounded-circle"
              />
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{
                currentUser.user.name
              }}</span>
            </span>
          </template>

          <b-dd-item to="/app/profile"
            ><i class="las la-user-circle"></i>My profile</b-dd-item
          >
          <b-dd-divider />
          <b-dd-item @click.prevent="logout"
            ><i class="las la-sign-out-alt"></i>Log Out</b-dd-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style>
.demo-navbar-messages .dropdown-menu,
.demo-navbar-notifications .dropdown-menu {
  overflow: scroll;
  max-height: 350px;
}
</style>

<script>
import Vue from "vue";
import NotificationService from "@/services/Notification/NotificationService";

export default {
  name: "app-layout-navbar",

  data: () => ({
    notification: [],
  }),

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    NotifTes() {
      return this.$store.state.notif.listNotification;
    },
    currentType() {
      return this.$store.state.auth.user.type;
    },
  },

  methods: {
    getNotification() {
      NotificationService.getNotification()
        .then((response) => {
          this.notification = response.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    showNewNotification() {
      Vue.$toast.open({
        message: "Ada Notifikasi Masuk!",
        type: "success",
        duration: "9000",
        // all of other options may go here
      });
    },

    updateread(id, tipe) {
      NotificationService.updateread(id)
        .then((response) => {
          if (tipe == 0) {
            window.location.href = "/app/merkuri/pesk";
          } else if (tipe == 1) {
            window.location.href = "/app/merkuri/alkes";
          } else if (tipe == 2) {
            window.location.href = "/app/shipping/pesk/interim";
          } else if (tipe == 3) {
            window.location.href = "/app/shipping/alkes/interim";
          } else if (
            this.$store.state.auth.user.role[0] == "agent_wms" &&
            this.$store.state.auth.user.type == 0
          ) {
            window.location.href = "/app/wms/receiving";
          } else if (
            this.$store.state.auth.user.role[0] == "agent_wms" &&
            this.$store.state.auth.user.type == 1
          ) {
            window.location.href = "/app/wms/pesk/provinsi/receiving";
          } else if (
            this.$store.state.auth.user.role[0] == "agent_wms" &&
            this.$store.state.auth.user.type == 2
          ) {
            window.location.href = "/app/wms/pesk/final/receiving";
          } else if (tipe == 8 || tipe == 9) {
            window.location.href = "/app/wms/dispatching";
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    updatestatus(notification) {
      this.$store.dispatch("notif/tesupdate", notification);
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    getLayoutNavbarBg() {
      return this.layoutNavbarBg;
    },

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },

  mounted() {
    window.Echo.private(
      "App.Models.Master.User." + this.$store.state.auth.user.user.id
    ).notification((notification) => {
      this.getNotification();

      this.showNewNotification();

      // this.$store.dispatch('notif/tes', notification)
    });
  },

  created() {
    this.getNotification();
  },
};
</script>
